export const EmptyStateSurface = {
  CARD: 'card',
  NONE: 'none',
} as const;

export type EmptyStateSurfaceType =
  (typeof EmptyStateSurface)[keyof typeof EmptyStateSurface];

export type EmptyStateTitleTag = 'h1' | 'h2' | 'h3';

export type EmptyStateProps = {
  id?: string;
  testId?: string;
  title: string;
  description?: string;
  svgImage?: string;
  svgTitle?: string;
  svgWidth?: number;
  svgHeight?: number;
  surface?: EmptyStateSurfaceType;
  fullWidth?: boolean;
  titleAs?: EmptyStateTitleTag;
};
